import { CustomFieldID } from '../customFields/customFieldsTypes';

export class CustomFieldValueCache {
  static customFieldCustomFieldValues(customFieldId: CustomFieldID) {
    return `custom-field-${customFieldId}-custom-field-values`;
  }
}
